<div class="componente-importantes text-start p-5 mt-3" style="min-height:700px;">
        <section class="">
        <form   class="row"
          action=""
          method="post"
          (submit)="formSubmit()"
          [formGroup]="Step5form"
        >
        <div class="col-4">
                <label for="formControlInput" class="form-label mt-5">Matríz de riesgo</label>
                <select required class="custom-outline-input form-select mt-3" formControlName="matrix_id" aria-label="Default select">
                <option selected value=""> Seleccione...</option>
                <option *ngFor="let item of listmatrix"[value]="item.id">{{item.name}}</option>
                </select>
        </div>
        <div class="col-4">
                <label for="formControlInput" class="form-label mt-5">Seleccione un grupo</label>
                <select required class="custom-outline-input form-select mt-3" formControlName="groups_id" aria-label="Default select">
                <option selected value=""> Seleccione...</option>
                <option *ngFor="let item of listgroup"[value]="item.id">{{item.name}}</option>
                </select>
        </div>
        <div class="col-4">
                <label for="formControlInput" class="form-label mt-5">Tipo de paga</label>
                <select required class="custom-outline-input form-select mt-3" formControlName="types_payment_id" aria-label="Default select">
                    <option selected value=""> Seleccione...</option>
                    <option *ngFor="let item of listpay"[value]="item.id">{{item.name}}</option>
                </select>
        </div>
        
        <div class="col-12 mt-4">
            <button class="mx-2 btn btn-outline-light " style="min-width: 250px ; float:right;" [disabled]="!Step5form.valid" > <i class="fa-solid fa-floppy-disk m-1" aria-hidden="true"></i> Guardar </button>
        </div>
        </form>
    </section>
    </div>